import axios from 'axios';
import {withAuth} from "../utils/authTokens";

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_CHATBOT_BACKEND}`,
  headers: {
    'Access-Control-Allow-Origin': '*',
    "Content-Type": "application/json"
  },
});

// token on every request, refreshed before it expires and on a 401 (see withAuth)
withAuth(instance);

export const setBaseURL = (url, registryProjectId) => {
  instance.defaults.baseURL = url;
  // Callers without a registry project clear it, so a previous project's id is not sent along
  if (registryProjectId) instance.defaults.headers.common["X-Project-Id"] = registryProjectId;
  else delete instance.defaults.headers.common["X-Project-Id"];
};


export default instance;
